module.exports = __webpack_public_path__ + "img/368.7acd3437.png";